import type { Language } from '@magicschool/supabase/types';
import type { MessageFormatElement } from 'react-intl';

const loadLocaleData = async (locale: Language) => {
  switch (locale) {
    case 'ar':
      return await import('@/features/locales/data/ar');
    case 'bg':
      return await import('@/features/locales/data/bg');
    case 'de':
      return await import('@/features/locales/data/de');
    case 'en-gb':
      return await import('@/features/locales/data/en-gb');
    case 'en-us':
      return await import('@/features/locales/data/en-us');
    case 'es-us':
      return await import('@/features/locales/data/es-us');
    case 'es-es':
      return await import('@/features/locales/data/es-es');
    case 'fr':
      return await import('@/features/locales/data/fr');
    case 'fr-ca':
      return await import('@/features/locales/data/fr-ca');
    case 'he':
      return await import('@/features/locales/data/he');
    case 'hi':
      return await import('@/features/locales/data/hi');
    case 'hr':
      return await import('@/features/locales/data/hr');
    case 'ht':
      return await import('@/features/locales/data/ht');
    case 'id':
      return await import('@/features/locales/data/id');
    case 'it':
      return await import('@/features/locales/data/it');
    case 'ja':
      return await import('@/features/locales/data/ja');
    case 'ko':
      return await import('@/features/locales/data/ko');
    case 'nl':
      return await import('@/features/locales/data/nl');
    case 'pt-BR':
      return await import('@/features/locales/data/pt-BR');
    case 'pt-PT':
      return await import('@/features/locales/data/pt-PT');
    case 'ru':
      return await import('@/features/locales/data/ru');
    case 'ukr':
      return await import('@/features/locales/data/ukr');
    case 'zh-cn':
      return await import('@/features/locales/data/zh-cn');
    case 'zh-hk':
      return await import('@/features/locales/data/zh-hk');
    case 'zh-tw':
      return await import('@/features/locales/data/zh-tw');
    default:
      return await import('@/features/locales/data/en-us');
  }
};

export type LocaleData = Record<string, string> | Record<string, MessageFormatElement[]>;

export const getLocaleData = (locale: Language) => loadLocaleData(locale).then((data) => data.default as LocaleData);
